import { FormattedMessage } from 'react-intl'

import { IconCrownUpgrade } from '@gto/ui/assets'
import { cn } from '@gto/ui/cn'
import { TicketIcon } from '@gto/ui/icons/solid'
import { Typography } from '@gto/ui/typography'

type DealLegendType = {
  variant: 'exclusive' | 'updates'
}
export const DealLegendBanner = ({ variant }: DealLegendType) => {
  const getVariant = () => {
    switch (variant) {
      case 'exclusive':
        return {
          icon: <IconCrownUpgrade />,
          tKey: 'deals.legend.exclusive' as const,
          colorClass: 'text-primary-main',
        }
      case 'updates':
        return {
          icon: <TicketIcon />,
          tKey: 'deals.legend.updates' as const,
          colorClass: 'text-text-primary',
        }
    }
  }

  const { icon, tKey, colorClass } = getVariant()

  return (
    <aside
      className={cn(
        'flex items-center justify-center gap-3 rounded-md border border-primary-main p-4 text-left md:text-center sm:p-2.5',
        colorClass,
      )}
    >
      <div
        className={cn(
          'flex size-6 shrink-0 items-center justify-center rounded-full p-1 text-primary-main',
          variant === 'exclusive' ? 'bg-primary-main/25' : 'bg-transparent',
        )}
      >
        {icon}
      </div>
      <Typography
        className="uppercase"
        variant="body3"
      >
        <FormattedMessage id={tKey} />
      </Typography>
    </aside>
  )
}
